import { getPostHogClient } from '../client';

const posthogProvider = {
  track: (eventName, properties) => {
    const client = getPostHogClient();
    client?.capture(eventName, properties);
  },

  identify: (distinctId, properties) => {
    const client = getPostHogClient();
    client?.identify(distinctId, properties);
  },

  reset: () => {
    const client = getPostHogClient();
    client?.reset();
  },
};

export default posthogProvider;
